export class City{
    id: number;
    location:string;
    country: string;
    header: string;
    aboutImage: string;
    poiImage: string;
    metaTitle: string;
    metaDescription: string;
    continent: number;
}